
















import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component
export default class Topbar extends Vue {
    rainbow(){
        const letters = (document.querySelectorAll('.rainbow span') as any);
        letters.forEach((span: { style: { animationDelay: string } }, i: number) => {
            span.style.animationDelay = `${-20 + i * 0.2}s`;
        });
    }
    mounted() {
        this.rainbow()
    }

    ok() {
        this.$emit('update');
    }
}
